import {ToastType} from '@sportcast/ui-react';
import i18n from 'i18next';
import {AppDispatch} from '../redux/rootReducer';
import {v4} from 'uuid';
import {MessageProps} from '../components/alert/Message';
import {hideLoader} from '../redux/action/loaderAction';
import {setMessage} from '../redux/action/messageAction';

export type StatusHandler = (error: unknown) => MessageProps

export interface ErrorJsonHandlerMap {
    [key: number]: StatusHandler;
}

const requestErrorHandler = (req: Promise<unknown>, method: string, dispatch: AppDispatch, statusHandler: ErrorJsonHandlerMap = {}) => {
    return req.catch((error: Response) => {
        let errorMessage: MessageProps;

        if (error.status === 401) {
            errorMessage = {
                message: 'No session.',
                messageId: v4(),
                i18nMessage: 'error.NO_SESSION',
                autoClose: false,
                type: ToastType.ERROR
            };
        } else if (error.status === 403) {
            // Permission denied from backend, this happens, when the token is invalid
            errorMessage = {
                message: i18n.t('error.NO_ACCESS', {method, url: error.url}),
                messageId: v4(),
                autoClose: true,
                type: ToastType.ERROR
            };
        } else if (error.status === 404) {
            errorMessage = {
                message: i18n.t('error.NOT_FOUND'),
                messageId: v4(),
                autoClose: true,
                type: ToastType.ERROR
            };
        } else if (error.body !== null && typeof error.json === 'function') {
            return error.json().then(json => {
                if (error.status && Object.prototype.hasOwnProperty.call(statusHandler, error.status)) {
                    dispatch(setMessage(statusHandler[error.status](json)));
                } else if (json.errorResponse?.message) {
                    dispatch(setMessage({
                        message: JSON.stringify(json.errorResponse.message),
                        messageId: v4(),
                        autoClose: true,
                        type: ToastType.ERROR,
                        autoCloseDuration: 5000,
                        i18nMessage: `errorCode.${json.errorResponse.errorCode}`
                    }));
                } else {
                    dispatch(setMessage({
                        message: i18n.t('error.ERROR_CALLING_BACKEND', {code: error.status, method, url: error.url}),
                        messageId: v4(),
                        autoClose: true,
                        type: ToastType.ERROR,
                        autoCloseDuration: 5000
                    }));
                }
                return Promise.resolve(json);
            }).catch((error) => {
                dispatch(setMessage({
                    message: error.message,
                    messageId: v4(),
                    autoClose: true,
                    type: ToastType.ERROR,
                    autoCloseDuration: 5000
                }));
            }).finally(() => dispatch(hideLoader()));
        } else if (!error.text || typeof error.text !== 'function') {
            errorMessage = {
                message: 'error',
                messageId: v4(),
                autoClose: true,
                type: ToastType.ERROR,
                autoCloseDuration: 5000
            };
        } else {
            const data = error.text();
            errorMessage = {
                message: JSON.stringify(data),
                messageId: v4(),
                autoClose: true,
                type: ToastType.ERROR,
                autoCloseDuration: 5000
            };
        }

        console.error('Can not push data. ' + error);
        dispatch(setMessage(errorMessage));
        dispatch(hideLoader());
        return errorMessage;
    });
};

export default requestErrorHandler;
